import PropTypes from "prop-types"
import { compose, withPropsOnChange, withProps } from "recompact"
import { connect } from "react-redux"
import pick from "ramda/es/pick"
import hocInterface from "src/helpers/hocInterface"
import { hasPermission } from "src/engine/modules/currentUser"
import {
  EVENT_CREATE,
  EVENT_DELETE,
  EVENT_UPDATE,
  EVENTS_CHANGE_STATUS,
} from "src/constants/knownPermissions"

/**
 * Переводит полномочия событий в пропы
 */
export default hocInterface(
  {
    injectProps: {
      planId: PropTypes.string,
    },
    exposeProps: pick([
      `isEventCreationEnabled`, // boolean
      `canEditEvent`, // function
      `canDeleteEvent`, // function
      `canChangeStatus`, // function
    ]),
  },
  compose(
    connect(state => ({
      canCreateEvent: hasPermission(EVENT_CREATE)(state),
      canEditEvent: hasPermission(EVENT_UPDATE)(state),
      canDeleteEvent: hasPermission(EVENT_DELETE)(state),
      canChangeStatus: hasPermission(EVENTS_CHANGE_STATUS)(state),
    })),
    withProps(({ canCreateEvent }) => ({
      isEventCreationEnabled: canCreateEvent,
    })),
    withPropsOnChange([`canEditEvent`], ({ canEditEvent }) => ({
      canEditEvent: () => canEditEvent,
    })),
    withPropsOnChange([`canDeleteEvent`], ({ canDeleteEvent }) => ({
      canDeleteEvent: () => canDeleteEvent,
    })),
    withPropsOnChange([`canChangeStatus`], ({ canChangeStatus }) => ({
      canChangeStatus: () => canChangeStatus,
    })),
  ),
)
